package one.healthium.insights.ui.components.items

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.domain.models.testTag
import one.healthium.insights.ui.utils.resolve
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black10
import one.healthium.ui.compose.theme.white
import org.jetbrains.compose.resources.painterResource

@Composable
fun ListItem(
    modifier: Modifier = Modifier,
    item: ContentEntry.ListItem,
    onClick: (ActionModel) -> Unit,
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 12.dp)
            .background(item.backgroundColor?.resolve() ?: white, AppTheme.shapes.medium)
            .clip(AppTheme.shapes.medium)
            .clickable { onClick(item.action) }
            .padding(12.dp)
            .testTag(item.action.testTag("list_item")),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        if (item.emoji != null) {
            Box(
                modifier = Modifier
                    .size(36.dp)
                    .background(black10, RoundedCornerShape(100)),
                contentAlignment = Alignment.Center,
            ) {
                Text(
                    text = item.emoji,
                    textAlign = TextAlign.Center,
                )
            }
        }
        if (item.title != null) {
            Spacer(Modifier.width(12.dp))
            Text(
                modifier = Modifier
                    .weight(1f)
                    .padding(bottom = 2.dp),
                text = item.title,
                style = AppTheme.textStyles.secondary_17_600,
                color = AppTheme.colors.text100,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
            Spacer(Modifier.width(8.dp))
        } else {
            Spacer(Modifier.weight(1f))
        }
        Image(
            painter = painterResource(AppIcons.icArrowRight),
            contentDescription = null
        )
    }
}